import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/workflows/user-workflow-documents/{userWorkflowDocumentId}/validation';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

/** Updates the validation status override for a filing packet document (manual approve/review). */
const updateDocumentValidation = async ({
  userWorkflowDocumentId,
  statusOfValidationStatus,
}: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { userWorkflowDocumentId });
  const response = await noodleApiClient.put(path, { statusOfValidationStatus });
  return response.data;
};

export default updateDocumentValidation;
